import React, { useState } from "react";
import { toast } from "sonner";
import { Camera, Upload } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { ProductCard } from "../components/ProductCard";
import { fileToCompressedDataUrl } from "../lib/image";

export default function VisualSearch() {
  const [image, setImage] = useState(null);
  const [products, setProducts] = useState([]);
  const [attrs, setAttrs] = useState(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    try {
      const d = await fileToCompressedDataUrl(f, 1080, 0.7);
      setImage(d); setBusy(true); setProducts([]); setAttrs(null);
      const r = await api("/visual-search", { method: "POST", body: JSON.stringify({ image_base64: d }) });
      setAttrs(r.attributes || null); setProducts(r.products || []);
    } catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="البحث بالصور" />
      <label className="flex flex-col items-center justify-center h-48 rounded-2xl border-2 border-dashed border-[#FF3D5A] bg-[#FFE5EA] cursor-pointer overflow-hidden" data-testid="visual-upload">
        {image ? <img src={image} alt="" className="w-full h-full object-contain" /> : <><Camera size={36} className="text-[#FF3D5A]" /><span className="text-sm text-[#FF3D5A] font-bold mt-2">ارفع صورة المنتج للبحث عنه</span></>}
        <input type="file" accept="image/*" className="hidden" onChange={onPick} />
      </label>
      {busy && <p className="text-center text-[#6B7280] mt-6">جارٍ تحليل الصورة...</p>}
      {attrs && (attrs.item_type || attrs.category) && (
        <div className="mt-4 flex gap-2 flex-wrap">
          {attrs.category && <span className="px-3 py-1.5 rounded-full bg-[#F0F2FA] text-sm font-bold">{attrs.category}</span>}
          {attrs.item_type && <span className="px-3 py-1.5 rounded-full bg-[#F0F2FA] text-sm font-bold">{attrs.item_type}</span>}
          {(attrs.colors || []).map((c, i) => <span key={i} className="px-3 py-1.5 rounded-full bg-[#F0F2FA] text-sm font-bold">{c}</span>)}
        </div>
      )}
      {products.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-5">{products.map((p) => <ProductCard key={p.product_id} item={p} />)}</div>
      )}
    </div>
  );
}
